const orderCarouselItems = (container, slides) => {
  const animationSlides = [...slides];
  const { textPosition, textAlignment } = container.dataset;
  const carouselOverhangs = textPosition === 'top';
  const carouselWraps = container.classList.contains(
    'carousel--columns-wrap-around'
  );

  if (carouselWraps && carouselOverhangs) {
    // Animate the last overhanging slide first
    animationSlides.unshift(animationSlides.pop());
  } else if (!carouselOverhangs && textAlignment == 'right') {
    // Reverse animation order
    animationSlides.reverse();
  }

  return animationSlides;
};

export default orderCarouselItems;
